import React from "react";
import cx from "classnames";

// images
import GoogleIcon from "../static/images/Google.svg";
import { Button } from "components/DesignSystem/Button/Button";

const GoogleBtn = ({ onClick, ...props }) => {
  return (
    <Button
      onClick={onClick}
      block
      size="regular"
      leftIcon={<img src={GoogleIcon} alt="Google" />}
    >
      Continue with Google
    </Button>
  );
};

export default GoogleBtn;
